import React from 'react';

import PropTypes from 'prop-types';

import './DynamicTabGrey.scss';

const Interface = {
  nameDict: PropTypes.object,
  listName: PropTypes.array,
  state: PropTypes.string,
  setState: PropTypes.func,
  disabled: PropTypes.bool
};

const DynamicTabGrey = ({
  listName = ['score_only', 'score_and_label', 'label_only'],
  state = 'Kobe',
  setState,
  disabled = false,
  nameDict = {
    label_only: 'Hide rating and show label only',
    score_and_label: 'Rating with label',
    score_only: 'Rating without label'
  }
}) => {
  return (
    <div className="dynamic-tab-grey relative">
      {disabled && (
        <div className="absolute h-full w-full opacity-50 rounded-md cursor-not-allowed z-index-99 bg-n-500" />
      )}
      {listName.map((val, idx) => {
        const name = val?.name || val;
        return (
          <p
            data-cy={'grey-tab-' + name.replace(/ /g, '-').toLowerCase()}
            onClick={() => !val?.disabled && !disabled && setState(name)}
            className={`
              tab-name relative
              ${name == state ? 'active' : 'bg-n-000'}
              ${
                val?.disabled
                  ? 'opacity-50 bg-n-500 !cursor-not-allowed !border-none'
                  : 'state-secondary-purple'
              }
            `}
            key={idx}
          >
            {nameDict[val] || name}
          </p>
        );
      })}
    </div>
  );
};

DynamicTabGrey.propTypes = Interface;

export default DynamicTabGrey;
